import React from 'react';
import {Dialog} from '../../controls';

import AircraftMovementList from "./components/AircraftMovementList";

const AircraftMovements = (props) => {
  const title = props.title || "Aircraft Movements";

  return (props.open ?
      <Dialog open={props.open}
              title={title}
              prefix=""
              width={1230}
              dialogOptions={{
                maxWidth:false,
              }}
              onChange={props.onChange}
      >
        <AircraftMovementList aircraftTailNumber={props.aircraftTailNumber} canEdit={props.canEdit}/>
      </Dialog>
      :<></>
  );
}

export default AircraftMovements;
